/**
 * shared/dom.ts —— DOM 与字符串小工具
 * 来历：一期 [SEC:icons] 段末尾的 $ / esc / cut 三个函数，逐字平移。
 *
 * ⚠ 【所有拼进 HTML 的用户数据必须过 esc()】。二期是真实多人系统，
 *   队伍名、课题、周报正文、临时参与人单位全都是用户输入；一期是 Mock 数据，
 *   漏一个 esc 看不出问题，二期漏一个就是一个存储型 XSS。
 *   判断方法：模板串里凡是 ${} 里不是数字、不是自己写死的常量，就该套 esc()。
 */

export const $ = <T extends Element = HTMLElement>(sel: string): T | null =>
  document.querySelector<T>(sel);

export const $$ = <T extends Element = HTMLElement>(sel: string, root: ParentNode = document): T[] =>
  Array.from(root.querySelectorAll<T>(sel));

/** HTML 转义。一期原实现，一字未改 */
export const esc = (s: unknown): string =>
  String(s == null ? '' : s).replace(
    /[&<>"]/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c] as string,
  );

/** 超长截断。⚠ 截断只是显示层的事，别把截断结果回写进任何提交入参 */
export const cut = (s: unknown, n: number): string => {
  const t = String(s == null ? '' : s);
  return t.length > n ? t.slice(0, n) + '…' : t;
};

/**
 * 条件片段：cond 为真才输出。
 * 一期到处写 `${x ? `<i>…</i>` : ''}`，这里收成一个函数只是为了少写一对三元。
 */
export const when = (cond: unknown, html: string): string => (cond ? html : '');
